import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useCart } from "../context/CartContext";
import { toast } from "react-hot-toast";
import { QRCodeCanvas } from "qrcode.react";

const Checkout = () => {
  const navigate = useNavigate();
  const { items, clearCart } = useCart();

  const [loading, setLoading] = useState(false);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });

  /* ---------------- CART TOTAL ---------------- */

  const totalPrice = items.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const discount = totalPrice * 0.1;
  const finalPrice = totalPrice - discount;

  /* ---------------- ORDER ID ---------------- */

  const orderId = "MS" + Math.floor(Math.random() * 1000000);

  /* ---------------- UPI LINK ---------------- */

  const upiLink = `upi://pay?pa=yourupi@upi&pn=Ms Bridal Wear&am=${finalPrice}&cu=INR`;

  /* ---------------- INPUT CHANGE ---------------- */

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ---------------- SCREENSHOT ---------------- */

  const handleScreenshot = (e) => {
    setPaymentScreenshot(e.target.files[0]);
  };

  /* ---------------- PLACE ORDER ---------------- */

  const handlePlaceOrder = async () => {
    setLoading(true);

    try {
      if (!formData.name || !formData.phone || !formData.address) {
        toast.error("Please fill required fields");
        setLoading(false);
        return;
      }

      const orderItems = items
        .map(
          (item) =>
            `${item.name} x ${item.quantity} - ₹${
              item.price * item.quantity
            }`
        )
        .join("\n");

      const message = `
🛍️ *New Order - Ms Bridal Wear*

🆔 Order ID: ${orderId}

👤 Name: ${formData.name}
📱 Phone: ${formData.phone}

📍 Address:
${formData.address}
${formData.city} ${formData.state}
${formData.pincode}

🛒 Items:
${orderItems}

💰 Amount: ₹${finalPrice}

Payment Done via UPI
`;

      const whatsappNumber = "918369560797";

      const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        message
      )}`;

      window.open(whatsappURL, "_blank");

      toast.success("Order Placed Successfully");

      clearCart();
      navigate("/order-confirmation");

    } catch (err) {
      console.error(err);
      toast.error("Checkout failed");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen pt-24 pb-16 px-4 bg-gray-50 dark:bg-black">
      <div className="max-w-7xl mx-auto">

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-4xl font-bold mb-10"
        >
          Secure Checkout
        </motion.h1>

        <div className="grid lg:grid-cols-2 gap-10">

          {/* BILLING */}

          <div className="bg-white p-8 rounded-2xl shadow-lg space-y-4">

            <input
              name="name"
              placeholder="Full Name"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

            <input
              name="phone"
              placeholder="Phone"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

            <textarea
              name="address"
              placeholder="Address"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

            <input
              name="city"
              placeholder="City"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

            <input
              name="state"
              placeholder="State"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

            <input
              name="pincode"
              placeholder="Pincode"
              onChange={handleInputChange}
              className="w-full p-3 border rounded-lg"
            />

          </div>

          {/* ORDER SUMMARY */}

          <div className="bg-white p-8 rounded-2xl shadow-lg">

            <h3 className="text-2xl font-bold mb-4">
              Order Summary
            </h3>

            <div className="flex justify-between mb-2">
              <span>Subtotal</span>
              <span>₹{totalPrice}</span>
            </div>

            <div className="flex justify-between text-green-600">
              <span>Discount</span>
              <span>-₹{discount}</span>
            </div>

            <hr className="my-4" />

            <div className="flex justify-between text-xl font-bold">
              <span>Total</span>
              <span>₹{finalPrice}</span>
            </div>

            {/* QR */}

            <div className="text-center mt-6">

              <p className="font-semibold">
                Scan & Pay
              </p>

              <div className="flex justify-center mt-3">
                <QRCodeCanvas value={upiLink} size={180} />
              </div>

              <p className="text-sm mt-2 text-gray-500">
                Pay via any UPI App
              </p>

            </div>

            {/* Screenshot */}

            <div className="mt-6">

              <label className="block mb-2">
                Upload Payment Screenshot
              </label>

              <input
                type="file"
                onChange={handleScreenshot}
                className="w-full"
              />

            </div>

            <motion.button
              onClick={handlePlaceOrder}
              disabled={loading}
              className="w-full mt-6 bg-black text-white py-3 rounded-xl"
            >
              {loading ? "Processing..." : "Place Order"}
            </motion.button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Checkout;